import { Skeleton } from "@/components/ui/skeleton";
import { Spinner } from "@/components/ui/spinner";

/** Shown inside the dashboard while a page's code or data loads. */
export function PageLoading() {
  return (
    <div className="flex flex-col gap-6" aria-busy="true" aria-label="Loading">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-8 w-56" />
        <Skeleton className="h-4 w-80" />
      </div>
      <div className="grid grid-cols-2 gap-4 xl:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton key={index} className="h-28 rounded-xl" />
        ))}
      </div>
      <Skeleton className="h-96 rounded-xl" />
    </div>
  );
}

/** First load, before the router has resolved the initial route. */
export function AppLoading() {
  return (
    <div
      className="text-muted-foreground flex min-h-dvh items-center justify-center"
      aria-busy="true"
    >
      <Spinner className="size-6" />
      <span className="sr-only">Loading Milqit Admin</span>
    </div>
  );
}
